<app-eula
  [showApproveButton]="true"
  [versionMatch]="versionMatch"
  [busy]="busy"
  (approved)="approved($event)"
>
</app-eula>
